import React, {Component} from "react";
import {connect} from "react-redux";
import {addToCoupon, addToCouponAndMakeBet} from "../../../redux/actions/coupon";
import Xhr from "../../../helpers/Xhr";

class Factor extends Component {
	state = {
		changeClass     : '',
		contentEditable : true,
	};

	componentWillReceiveProps(nextProps) {
		if ( nextProps.item.v !== this.props.item.v ) {
			let upDown = 'factor-colorize-up';
			if ( nextProps.item.v < this.props.item.v ) {
				upDown = 'factor-colorize-down';
			}

			this.setState({
				changeClass : `animated flash factor-colorize ${upDown}`
			});

			setTimeout(() => {this.setState({changeClass : ''})}, 3000);
		}
	}

	addToCoupon() {
		const {item, oneclick, type, user} = this.props;

		if ( user.info.role === 'root' || user.info.role === 'bookmaker' ) {
			const newVal = prompt('Введите значение кефа: ', this.props.item.v);
			if ( newVal !== '' && newVal !== null ) {
				item.v = newVal;

				Xhr.setFactor(item.e, item).then((resp) => {

				});
			}
		}
		else {
			if ( type === 'live' && oneclick.isOneClick ) {
				const data = {
					amount : oneclick.amount,
					clear  : 1,
					gold   : 1
				};

				this.props.onAddToCouponAndMakeBet(item.e, item.f, type, data);
			}
			else {
				this.props.onAddToCoupon(item.e, item.f);
			}
		}
	}

	render() {
		const {item} = this.props;

		return (
			<span className={`f-value ${this.state.changeClass}`}
			      onClick={this.addToCoupon.bind(this)}>{item.v}</span>
		);
	}
}

export default connect(
	state => ({
		user     : state.user,
		oneclick : state.oneclick
	}),
	dispatch => ({
		onAddToCoupon           : (eventId, hash) => {
			dispatch(addToCoupon(eventId, hash));
		},
		onAddToCouponAndMakeBet : (eventId, hash, type, data) => {
			dispatch(addToCouponAndMakeBet(eventId, hash, type, data));
		}
	})
)(Factor);


// WEBPACK FOOTER //
// ./src/app/components/EventById/Event/Factor.js